// extracted by mini-css-extract-plugin
export default {"cases":"MainPage_cases__PHCw2","artifacts":"MainPage_artifacts__AAeAO","links":"MainPage_links__rdobH","content":"MainPage_content__TXWn4"};